/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import api from "../../utils/api";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import { RingLoader } from "react-spinners";
import he from "he";
import "./ViewPaper.css";
import { TextAlignJustify, TextColumns } from "@phosphor-icons/react";
import * as XLSX from "xlsx"; // Import XLSX library
import classNames from "classnames";
import print from "../../assets/logo/print.jpeg";
import parse from "html-react-parser";
import PptxGenJS from "pptxgenjs";// import "./PickQuestions.css"
import { toast, ToastContainer } from "react-toastify";
import { get } from "jquery";

const ViewPaper = () => {





  const exportToExcel = () => {
    const tableData = [];

    Object.entries(activeQuestionsBySection).forEach(([sectionNumber, section]) => {
      section.questions.forEach((question, index) => {
        tableData.push({
          "Question No": index + 1 + section.startIndex,
          "Correct Option":
            optionFormat === "alphabets"
              ? String.fromCharCode(64 + Number(question.optionId)) // convert to a, b, c...
              : question.optionId,
        });
      });
    });

    const ws = XLSX.utils.json_to_sheet(tableData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Questions");
    XLSX.writeFile(wb, "questions.xlsx");
  };

  const truncateText = (text, maxLength = 30000) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const exportToExcel2 = () => {
    const excelData = [];

    Object.entries(activeQuestionsBySection).forEach(([sectionNumber, section]) => {
      // Add section header
      excelData.push([section.sectionName, "", "", ""]);

      section.questions.forEach((question, index) => {
        const formattedOptions = question.options
          ?.map(
            (opt, idx) =>
              `${optionFormat === "Alphabet"
                ? String.fromCharCode(97 + idx)
                : idx + 1
              }. ${opt}`
          )
          .join("\n");

        // Ensure text doesn't exceed Excel limits
        const truncatedQuestion = renderLatexText(question.question);
        const truncatedOptions = renderLatexText(formattedOptions);
        const truncatedAnswer = renderLatexText(question.answer);
        const truncatedExplanation = renderLatexText(question.explanation);

        // Add question row
        excelData.push([
          `Q${index + 1 + section.startIndex}. ${truncatedQuestion}`,
          truncatedOptions || "Ans. ________", // If no options, leave answer space
          `Answer: ${truncatedAnswer}`,
          `Explanation: ${truncatedExplanation}`,
        ]);
      });

      // Add empty row for spacing
      excelData.push(["", "", "", ""]);
    });

    // Convert array to a worksheet
    const ws = XLSX.utils.aoa_to_sheet(excelData);

    // Create a workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Questions");

    // Write file and trigger download
    XLSX.writeFile(wb, "Question_Paper.xlsx");
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [paperName, setPaperName] = useState("");
  const [duration, setDuration] = useState("");
  const [startDate, setStartDate] = useState("");
  const [checkedForSets, setCheckedForSets] = useState(false);


  useEffect(() => {
    setPaperName(queryParams.get("paperName") || "");
    setDuration(queryParams.get("duration") || "");
    setStartDate(queryParams.get("startDate") || "");
  }, [location.search]);

  // Format duration in hours
  const durationInHours = duration ? `${parseInt(duration) / 60} hrs` : "";

  // Format date as DD/MM/YYYY
  const formattedDate = startDate
    ? new Date(startDate).toLocaleDateString("en-GB")
    : "";

  const [fontSize, setFontSize] = useState("9px");
  const [fontStyle, setFontStyle] = useState("'Open Sans', sans-serif");
  const [selected, setSelected] = useState("btnradio1");
  const [fetchedData, setFetchedData] = useState([]);

  const [layout, setLayout] = useState("single"); // single or double column
  const [boldQuestions, setBoldQuestions] = useState(false); // State to toggle bold questions
  const [roughSpace, setRoughSpace] = useState(10);
  const [optionLayout, setOptionLayout] = useState("1");
  const [optionFormat, setOptionFormat] = useState("alphabets");
  const [printForTeacher, setPrintForTeacher] = useState(false); // NEW STATE
  const [showChaptersCovered, setShowChaptersCovered] = useState(false); // State for toggling "Topics Covered"
  const [showTopicsCovered, setShowTopicsCovered] = useState(false); // State for toggling "Topics Covered"
  const [topicsCovered, setTopicsCovered] = useState([]);
  const [sectionsData, setSectionsData] = useState([]);

  const [questionsBySection, setQuestionsBySection] = useState({});
  const [loading, setLoading] = useState(false); // Loader state
  const navigate = useNavigate(); // Use navigate for routing
  const [showWatermark, setShowWatermark] = useState(false);
  const [numberOfSets, setNumberOfSets] = useState("1");
  const [generatedSets, setGeneratedSets] = useState([]);
  const [selectedSet, setSelectedSet] = useState("");
  const [hasGeneratedSets, setHasGeneratedSets] = useState(false);
  const [setQuestions, setSetQuestions] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);

  const [isSetQuestionsReady, setIsSetQuestionsReady] = useState(false);
  const [showOriginalPaper, setShowOriginalPaper] = useState(false);

  const [forcedTwoCol, setForcedTwoCol] = useState({});
  const [singlePrintMode, setSinglePrintMode] = useState(false);
  const [singlePPTMode, setSinglePPTMode] = useState(false);

  useEffect(() => {
    const existing = document.getElementById("dynamic-print-style");
    if (existing) existing.remove();

    const style = document.createElement("style");
    style.id = "dynamic-print-style";
    if (singlePrintMode) {
      style.innerHTML = `
    @media print {

      @page {
        size: 33.87cm 19.05cm;
        margin: 0;
      }

      html, body {
        margin: 0 !important;
        padding: 0 !important;
      }

    }
  `;
    } else {
      style.innerHTML = `
      @media print {
        @page {
          margin: 10mm !important;
        }

        html, body {
          background: white !important;
        }
      }
    `;
    }

    document.head.appendChild(style);

    return () => {
      const el = document.getElementById("dynamic-print-style");
      if (el) el.remove();
    };
  }, [singlePrintMode]);


  // ✅ MUST BE HERE (ABOVE ALL USAGE)
  // true only when sets exist AND user has NOT selected original paper
  const isSetMode = hasGeneratedSets && !showOriginalPaper;

  // 🔑 Stable key for question (works for original + sets)
  const getQuestionKey = (question) =>
    isSetMode ? question.questionId : question.id;


  const activeQuestionsBySection =
    isSetMode
      ? isSetQuestionsReady
        ? questionsBySection
        : {}
      : questionsBySection; // original paper




  const { id } = useParams();

  useEffect(() => {
    async function fetchTemplateDetails() {
      try {
        const fd = new FormData();
        fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
        fd.append("token", localStorage.getItem("authToken"));
        fd.append("programType", "getTemplateDetailsInAddQuestions");
        fd.append("id", id);

        const response = await api.post("paper/paperCurl", fd);
        console.log("rawwwwwwwwwwwwwwwwwwwww", response)
        const templateDetails = JSON.parse(response.data.data[0].details);

        console.log("Raw template details:", templateDetails);

        let sections = templateDetails.sections;

        if (!Array.isArray(sections)) {
          sections = Object.values(sections);
        }

        // Process each section to normalize subjects
        sections = sections.map(section => {
          const processedSection = { ...section };

          // Normalize subjects to be accessible by subjectId
          if (section.subjects && typeof section.subjects === 'object') {
            // If it's already an array, keep it
            if (Array.isArray(section.subjects)) {
              // Convert to object with subjectId as key for easier access
              const subjectsObj = {};
              section.subjects.forEach(subject => {
                subjectsObj[subject.subjectId] = subject;
              });
              processedSection.subjects = subjectsObj;
            }
            // If it's an object with numeric keys (like {5: {...}, 6: {...}})
            else {
              // Ensure keys are strings
              const normalizedSubjects = {};
              Object.entries(section.subjects).forEach(([key, subject]) => {
                normalizedSubjects[subject.subjectId || key] = subject;
              });
              processedSection.subjects = normalizedSubjects;
            }
          }

          return processedSection;
        });

        console.log("Processed sections:", sections);
        setSectionsData(sections);

      } catch (error) {
        console.error("Error fetching template details:", error);
      }
    }
    fetchTemplateDetails();
  }, [id]);

  useEffect(() => {
    async function fetchData() {
      try {
        if (sectionsData.length === 0) {
          return;
        }

        setLoading(true);

        const fd = new FormData();
        fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
        fd.append("token", localStorage.getItem("authToken"));
        fd.append("programType", "printQuestions");
        fd.append("paperId", id);

        const response = await api.post("picQuestion/picQuestionCurl", fd);
        console.log("qqqqqqqqqqqqqqqq", response)

        // console.log("=== FETCHING DATA ===");
        let questions = response.data || [];
        // console.log(`Total questions fetched: ${questions.length}`);

        // Count by subject for debugging
        const subjectCounts = {};
        questions.forEach(q => {
          const subId = q.subjectId;
          subjectCounts[subId] = (subjectCounts[subId] || 0) + 1;
        });
        console.log("Questions by subject:", subjectCounts);

        // Log all available subjects
        const availableSubjects = Object.keys(subjectCounts).map(Number);
        console.log("Available subjects in data:", availableSubjects);

        setFetchedData(questions);

        let sectionsWithQuestions = {};

        // Initialize sections from template
        sectionsData.forEach((section) => {
          const sectionNum = section.sectionNumber;
          sectionsWithQuestions[sectionNum] = {
            sectionName: section.sectionName || `Section ${sectionNum}`,
            questions: [],
            subjectCount: {},
            totalQuestionsAdded: 0,
            startIndex: 0
          };
        });

        console.log("Sections initialized:", Object.keys(sectionsWithQuestions));

        // Sort sections by sectionNumber
        const sortedSections = [...sectionsData].sort((a, b) => a.sectionNumber - b.sectionNumber);

        // Create a copy of questions to work with
        let availableQuestions = [...questions];

        // Process each section in order
        sortedSections.forEach((section) => {
          const sectionNum = section.sectionNumber;
          const sectionConfig = sectionsWithQuestions[sectionNum];

          console.log(`\n=== Processing Section ${sectionNum} ===`);
          console.log(`Section requirements:`, {
            questionType: section.questionType,
            totalQuestions: section.totalQuestions,
            subjects: section.subjects
          });

          // Get subject requirements for this section
          const subjectRequirements = {};
          if (section.subjects) {
            Object.values(section.subjects).forEach(subjectReq => {
              subjectRequirements[subjectReq.subjectId] = parseInt(subjectReq.noOfQuestions) || 0;
            });
          }

          console.log(`Subject requirements:`, subjectRequirements);

          // Process each available question
          const questionsForThisSection = [];
          const usedQuestionIds = new Set();

          // First pass: Try to fulfill subject requirements
          Object.entries(subjectRequirements).forEach(([subjectId, requiredCount]) => {
            if (requiredCount > 0) {
              console.log(`  Looking for ${requiredCount} questions for Subject ${subjectId}`);

              // Find questions for this subject that match the section's question type
              const matchingQuestions = availableQuestions.filter(q =>
                String(q.subjectId) === String(subjectId) &&
                String(q.questionType) === String(section.questionType) &&
                !usedQuestionIds.has(q.id)
              );

              console.log(`Found ${matchingQuestions.length} matching questions`);

              // Take only as many as needed
              const questionsToAdd = matchingQuestions.slice(0, requiredCount);

              questionsToAdd.forEach(q => {
                questionsForThisSection.push(q);
                usedQuestionIds.add(q.id);

                // Update counters
                sectionConfig.subjectCount[subjectId] = (sectionConfig.subjectCount[subjectId] || 0) + 1;
                sectionConfig.totalQuestionsAdded += 1;
              });

              console.log(`    Added ${questionsToAdd.length} questions`);
            }
          });

          // Remove used questions from available pool
          availableQuestions = availableQuestions.filter(q => !usedQuestionIds.has(q.id));

          // Add questions to section
          sectionConfig.questions = questionsForThisSection;

          console.log(`Section ${sectionNum} total after processing: ${sectionConfig.questions.length} questions`);
          console.log(`Remaining available questions: ${availableQuestions.length}`);
        });

        // Handle any remaining questions (if any sections didn't get their full allocation)
        if (availableQuestions.length > 0) {
          console.warn(`\n⚠️ ${availableQuestions.length} questions remain unassigned after processing all sections`);

          // Distribute remaining questions to sections that need more
          sortedSections.forEach((section) => {
            const sectionNum = section.sectionNumber;
            const sectionConfig = sectionsWithQuestions[sectionNum];
            const sectionLimit = parseInt(section.totalQuestions) || 0;

            // Check if this section needs more questions
            if (sectionConfig.totalQuestionsAdded < sectionLimit && availableQuestions.length > 0) {
              const needed = sectionLimit - sectionConfig.totalQuestionsAdded;
              const questionsToAdd = availableQuestions.slice(0, needed);

              if (questionsToAdd.length > 0) {
                console.log(`Adding ${questionsToAdd.length} remaining questions to Section ${sectionNum}`);

                questionsToAdd.forEach(q => {
                  sectionConfig.questions.push(q);
                  const subjectId = q.subjectId;
                  sectionConfig.subjectCount[subjectId] = (sectionConfig.subjectCount[subjectId] || 0) + 1;
                  sectionConfig.totalQuestionsAdded += 1;
                });

                // Remove from available pool
                availableQuestions = availableQuestions.slice(needed);
              }
            }
          });
        }

        // Calculate startIndex for each section
        let cumulativeIndex = 0;
        Object.values(sectionsWithQuestions).forEach(section => {
          section.startIndex = cumulativeIndex;
          cumulativeIndex += section.questions.length;
        });

        // Final summary
        console.log("\n=== FINAL SECTION DISTRIBUTION ===");
        Object.entries(sectionsWithQuestions).forEach(([sectionNum, section]) => {
          console.log(`Section ${sectionNum}: ${section.questions.length} questions`);
          console.log(`  Subject counts:`, section.subjectCount);
          console.log(`  Start index: ${section.startIndex}`);
        });

        console.log(`Total questions in all sections: ${cumulativeIndex} out of ${questions.length} total questions`);

        setQuestionsBySection(sectionsWithQuestions);

      } catch (error) {
        console.error("Error fetching questions:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();


  }, [id, sectionsData, checkedForSets, hasGeneratedSets, showOriginalPaper]);

  async function fetchTopics() {
    try {
      const fd = new FormData();
      fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
      fd.append("token", localStorage.getItem("authToken"));
      fd.append("programType", "getChapterAndTopicDetailsForPaper");
      // console.log("id", id);
      fd.append("paperId", id);

      const response = await api.post("picQuestion/picQuestionCurl", fd);
      // console.log("Topics Response:", response.data);

      setTopicsCovered(response.data); // Assuming response.data contains the topics data
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  }

  let cumulativeIndex = 0;

  Object.entries(activeQuestionsBySection).forEach(([sectionNumber, section]) => {
    section.startIndex = cumulativeIndex; // Set start index for each section
    cumulativeIndex += section.questions.length; // Update the cumulative index for the next section
  });

  const renderLatexText = (text, layout = "single", fontSize = "16px") => {
    if (!text) return null;

    // Step 1: Decode HTML entities so <br/> becomes an actual tag
    let decodedText = he.decode(text);

    // Step 2: Replace <br> tags with newline characters
    decodedText = decodedText.replace(/<br\s*\/?>/gi, "\n");

    // Step 3: Regex for latex and images
    const latexAndImageRegex =
      /\\\((.*?)\\\)|\\\[(.*?)\\\]|<img[^>]*\bsrc=(["'])(.*?)\3[^>]*>|\\begin{align}([\s\S]*?)\\end{align}/g;

    const parts = [];
    let lastIndex = 0;
    let match;
    let key = 0;

    while ((match = latexAndImageRegex.exec(decodedText)) !== null) {
      const [fullMatch, inlineLatex, blockLatex, , imageSrc, alignContent] =
        match;
      const matchIndex = match.index;

      if (matchIndex > lastIndex) {
        const plainText = decodedText.slice(lastIndex, matchIndex);

        // Split plain text on \n and insert <br />
        plainText.split("\n").forEach((line, i, arr) => {
          if (line) parts.push(<span className="3 normal-inline" key={`html-${key++}`}>{parse(line)}</span>);
          if (i < arr.length - 1) parts.push(<br key={`br-${key++}`} />);
        });
      }

    if (imageSrc) {
  parts.push(
    <img
      key={`img-${key++}`}
      src={imageSrc}
      alt="Image"
      style={{
        maxWidth: singlePrintMode
          ? `calc(${fontSize} * 16)`   // 🔥 smaller in single question mode
          : `calc(${fontSize} * 18)`,  // normal size
        maxHeight: singlePrintMode ? "380px" : "auto",
        display: "inline",
        verticalAlign: "middle",
        marginLeft: "4px",
        marginRight: "4px",
      }}
    />
  );
} else if (alignContent) {
        parts.push(
          <BlockMath key={`align-${key++}`}>
            {`\\begin{align}${alignContent}\\end{align}`}
          </BlockMath>
        );
      } else if (inlineLatex || blockLatex) {
        parts.push(
          <InlineMath key={`inline-${key++}`}>
            {inlineLatex || blockLatex}
          </InlineMath>
        );
      }

      lastIndex = matchIndex + fullMatch.length;
    }

    if (lastIndex < decodedText.length) {
      const remaining = decodedText.slice(lastIndex);
      remaining.split("\n").forEach((line, i, arr) => {
        if (line) parts.push(<span className="2 normal-inline" key={`html-${key++}`}>{parse(line)}</span>);
        if (i < arr.length - 1) parts.push(<br key={`br-${key++}`} />);
      });
    }

    return <span className="1 " style={{ whiteSpace: "normal", display: "inline" }}>{parts}</span>;
  };




  const getButtonClass = (radioId) => {
    return {
      backgroundColor: selected === radioId ? "black" : "#f8f9fa", // Blue background for selected, light gray for unselected
      color: selected === radioId ? "#fff" : "#000", // White text for selected, black text for unselected
      borderColor: selected === radioId ? "black" : "#ccc", // Blue border for selected, gray border for unselected
      fontWeight: "bold", // Add bold text to make it stand out
      padding: "10px 10px", // Padding for better button appearance
      cursor: "pointer", // Cursor pointer for better user experience
      borderRadius: radioId === "btnradio1" ? "10px 0 0 10px" : "0 10px 10px 0",
      transition:
        "background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease", // Smooth transition for background, text, and border colors
    };
  };

  const handleCheckboxChange = () => {
    setShowTopicsCovered(!showTopicsCovered); // Toggle visibility of "Topics Covered"
  };

  const handleCheckboxChange2 = () => {
    setShowChaptersCovered(!showChaptersCovered); // Toggle visibility of "Topics Covered"
  };


  async function handleGenerateSets() {
    try {
      setIsGenerating(true); // ✅ START BUTTON LOADER

      const fd = new FormData();
      fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
      fd.append("token", localStorage.getItem("authToken"));
      fd.append("programType", "generateOMRSets");
      fd.append("paperId", id);
      fd.append("numberOfSets", numberOfSets);

      const response = await api.post("omr/omrDetails", fd);

      // console.log("✅ OMR Sets Generated:", response);
      toast.success(response.data.message || "OMR Sets Generated Successfully!");
      await fetchGenerateSets()
      if (response.data.success) {
        await fetchGenerateSets(); // ✅ REFRESH SET LIST
        navigate(0); // ✅ RELOAD PAGE TO REFLECT CHANGES
      }

    } catch (error) {
      console.error("❌ Error generating OMR sets:", error);
    } finally {
      setIsGenerating(false); // ✅ STOP BUTTON LOADER
    }
  }

  async function fetchGenerateSets() {
    try {
      const fd = new FormData();
      fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
      fd.append("token", localStorage.getItem("authToken"));
      fd.append("programType", "getPaperSets");
      fd.append("paperId", id);

      const response = await api.post("omr/omrDetails", fd);

      if (
        response.data?.status === "success" &&
        response.data?.sets?.length > 0
      ) {
        setGeneratedSets(response.data.sets);
        setHasGeneratedSets(true);

        const firstSet = response.data.sets[0].setNumber;
        setSelectedSet(firstSet);
        setIsSetQuestionsReady(false);
      } else {
        setGeneratedSets([]);
        setHasGeneratedSets(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCheckedForSets(true); // ✅ IMPORTANT
    }
  }



  async function fetchSet(setNumber) {
    try {
      setLoading(true);
      setIsSetQuestionsReady(false); // ⛔ hide old content

      const fd = new FormData();
      fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
      fd.append("token", localStorage.getItem("authToken"));
      fd.append("programType", "getQuestionsForSet");
      fd.append("paperId", id);
      fd.append("setNumber", setNumber);

      const response = await api.post("omr/omrDetails", fd);

      if (
        response.data?.status === "success" &&
        Array.isArray(response.data.sections)
      ) {
        const sectionMap = {};

        response.data.sections.forEach((section) => {
          sectionMap[section.sectionNumber] = {
            sectionName: section.sectionName,
            questions: section.questions || [],
          };
        });

        setQuestionsBySection(sectionMap);
        setIsSetQuestionsReady(true); // ✅ NOW SAFE TO RENDER
      } else {
        setQuestionsBySection({});
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (
      hasGeneratedSets &&
      !showOriginalPaper &&
      selectedSet
    ) {
      fetchSet(selectedSet);
    }
  }, [showOriginalPaper]);



  useEffect(() => {


    if (selectedSet) {
      fetchSet(selectedSet); // ✅ AUTO LOAD QUESTIONS FOR SELECTED SET
      // console.log("sssssssssssssss")
    }
  }, [selectedSet]);



  useEffect(() => {
    fetchGenerateSets()
    fetchTopics();
  }, []);

  useEffect(() => {
    window.addEventListener("afterprint", () => {
      document.querySelectorAll(".print-page-number").forEach((el) => {
        el.innerHTML = "";
      });
    });
  }, []);


  useEffect(() => {
    setForcedTwoCol({});
  }, [selectedSet, showOriginalPaper]);



  const renderTopics = () => {
    return topicsCovered.map((subject) => (
      <div key={subject.subjectId}>
        <p>
          <strong>{subject.subjectName}</strong>
        </p>
        <div>
          {subject.chapters.map((chapter) => (
            <div style={{ display: "flex" }} key={chapter.chapterId}>
              <p style={{ fontWeight: "600" }}>{chapter.chapterName}:</p>

              {chapter.topics.map((topic) => (
                <p key={topic.topicId}>{topic.topicName},</p>
              ))}
            </div>
          ))}
        </div>
      </div>
    ));
  };

  const renderChapters = () => {
    return topicsCovered.map((subject) => (
      <div key={subject.subjectId}>
        <p>
          <strong>{subject.subjectName}</strong>
        </p>
        <div>
          <span style={{ display: "flex" }}>
            <b style={{ marginRight: "5px" }}>Chapter :-</b>
            <span style={{ fontWeight: "600", flexWrap: "wrap", display: "flex", gap: "5px" }}>
              {subject.chapters.map((chapter, index) => (
                <span key={chapter.chapterId}>
                  {chapter.chapterName}
                  {index < subject.chapters.length - 1 ? "," : ""}
                </span>
              ))}
            </span>
          </span>
        </div>
      </div>
    ));
  };


  // Example: Ensuring reflow happens before print
  const handlePrint = (forTeacher = false) => {
    // If Single Question per Page is checked, generate PPT instead of printing
    // PPT mode
    if (singlePPTMode) {
      generatePPT();
      return;
    }

    // Print mode
    if (singlePrintMode) {
      setPrintForTeacher(forTeacher);

      setTimeout(() => {
        window.print();
      }, 100);

      return;
    }

    setPrintForTeacher(forTeacher);
    setTimeout(() => {
      const printHandler = () => {
        setPrintForTeacher(false);
        window.removeEventListener('afterprint', printHandler);
      };
      window.addEventListener('afterprint', printHandler);
      window.print();
    }, 100);
  };

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--paper-font",
      fontStyle
    );
  }, [fontStyle]);
  const toggleForceTwoCol = (qid) => {
    setForcedTwoCol((prev) => ({
      ...prev,
      [qid]: !prev[qid],
    }));
  };
  const getSmartOptionLayout = (options = []) => {
    if (!options || options.length === 0) return "stack";

    const lengths = options.map(opt =>
      he.decode(opt || "").replace(/<[^>]+>/g, "").trim().length
    );

    const maxLen = Math.max(...lengths);

    // small options → single row
    if (maxLen <= 25) return "single-row";

    // medium & big options → 2 column
    if (maxLen <= 300) return "two-column";

    // extremely large → stack
    return "stack";
  };
  const isSinglePrintMode = singlePrintMode;

  const cleanTextForPPT = (text) => {
    if (!text) return "";
    let decoded = he.decode(text);
    // Replace <br> with actual newlines
    decoded = decoded.replace(/<br\s*\/?>/gi, "\n");
    // Remove remaining HTML tags but keep the content
    return decoded.replace(/<\/?[^>]+(>|$)/g, "");
  };

  const stripHtml = (text) => {
    if (!text) return "";
    let decoded = he.decode(text);
    decoded = decoded.replace(/<br\s*\/?>/gi, "\n");
    return decoded.replace(/<\/?[^>]+(>|$)/g, "");
  };
  const generatePPT = () => {
    const pres = new PptxGenJS();
    pres.layout = "LAYOUT_WIDE";

    const allQuestions = Object.values(activeQuestionsBySection).flatMap(
      (section) => section.questions
    );

    if (allQuestions.length === 0) {
      toast.error("No questions available to export.");
      return;
    }

    /**
     * Advanced Helper to clean LaTeX leftovers and convert symbols
     */
    const formatMathForPPT = (text) => {
      if (!text) return "";

      let str = he.decode(text);

      // Replace <br>
      str = str.replace(/<br\s*\/?>/gi, "\n");

      // ===============================
      // REMOVE \left and \right
      // ===============================
      str = str.replace(/\\left/g, "");
      str = str.replace(/\\right/g, "");

      // ===============================
      // HANDLE \mathrm{...} and mathrm~
      // ===============================
      str = str.replace(/\\mathrm\s*\{([^}]*)\}/g, "$1");
      str = str.replace(/\\?mathrm~?/g, "");

      // ===============================
      // FRACTIONS
      // ===============================

      // \frac{a}{b}
      str = str.replace(/\\frac\s*\{([^}]*)\}\s*\{([^}]*)\}/g, "($1/$2)");

      // \frac a b
      str = str.replace(/\\frac\s*([a-zA-Z0-9^_\-]+)/g, "$1/");

      // leftover fracn^2 Rn-1
      str = str.replace(/frac([a-zA-Z0-9^_\-]+)/g, "$1");

      // ===============================
      // SQRT
      // ===============================
      str = str.replace(/\\sqrt\s*\{([^}]*)\}/g, "√($1)");

      // ===============================
      // SYMBOL CONVERSIONS
      // ===============================
      str = str
        .replace(/\\lambda/g, "λ")
        .replace(/\\pi/g, "π")
        .replace(/\\Omega/g, "Ω")
        .replace(/\\theta/g, "θ")
        .replace(/\\alpha/g, "α")
        .replace(/\\beta/g, "β")
        .replace(/\\gamma/g, "γ")
        .replace(/\\times/g, "×")
        .replace(/\\pm/g, "±");

      // ===============================
      // DEGREE FIX (CRITICAL)
      // handles ALL cases:
      // ^\circ
      // ^ °
      // ^°
      // ===============================
      str = str.replace(/\^\s*\\circ/g, "°");
      str = str.replace(/\^\s*°/g, "°");

      // now convert remaining \circ
      str = str.replace(/\\circ/g, "°");

      // ===============================
      // SUPERSCRIPTS
      // ===============================
      str = str.replace(/\^\{([^}]*)\}/g, "$1"); // remove ^ but keep value
      str = str.replace(/\^([0-9]+)/g, "^$1");   // keep for exponents like 10^-2

      // ===============================
      // SUBSCRIPTS
      // ===============================
      str = str.replace(/_\{([^}]*)\}/g, "_$1");

      // ===============================
      // REMOVE WRAPPERS
      // ===============================
      str = str.replace(/\\\(|\\\)|\\\[|\\\]/g, "");

      // Remove HTML
      str = str.replace(/<\/?[^>]+(>|$)/g, "");

      // Remove extra slashes/braces
      str = str.replace(/[\\{}]/g, "");

      // Fix multiple spaces
      str = str.replace(/\s+/g, " ");

      return str.trim();
    };

    /**
     * Helper to find all <img> src attributes in a string
     */
    const extractImages = (html) => {
      const imgRegex = /<img[^>]*src=["']([^"']+)["'][^>]*>/gi;
      let images = [];
      let match;
      while ((match = imgRegex.exec(html)) !== null) {
        images.push(match[1]);
      }
      return images;
    };

    allQuestions.forEach((q, index) => {
      const slide = pres.addSlide();

      const questionImages = extractImages(q.question);
      const cleanQuestion = formatMathForPPT(q.question.replace(/<img[^>]*>/gi, ""));

      // 1️⃣ Add Question Text
      slide.addText(`${index + 1}. ${cleanQuestion}`, {
        x: 0.5,
        y: 0.4,
        w: 12.0,
        fontSize: 14,
        fontFace: "Arial",
        color: "363636",
        valign: "top",
      });

      // 2️⃣ Calculate starting point for images (below text)
      const estimatedLines = Math.ceil(cleanQuestion.length / 100) || 1;
      let currentY = 0.4 + (estimatedLines * 0.28) + 0.2;

      // 3️⃣ Place Question Images (SMALLER SIZE)
      const qImageWidth = 3.5;  // Reduced from 5.0
      const qImageHeight = 1.8; // Reduced from 2.5

      questionImages.forEach((imgSrc) => {
        try {
          slide.addImage({
            path: imgSrc,
            x: 0.8,
            y: currentY,
            w: qImageWidth,
            h: qImageHeight,
            sizing: { type: "contain", w: qImageWidth, h: qImageHeight }
          });
          // Increment currentY so options start below the image
          currentY += (qImageHeight + 0.2);
        } catch (err) {
          console.error("PPT Q-Image Error");
        }
      });

      // 4️⃣ Final Start Y for options
      let optionsStartY = currentY + 0.1;

      // --- RENDER OPTIONS ---
      if (q.options && q.options.length > 0) {
        const col1X = 0.8;
        const col2X = 6.5;

        const hasImagesInOptions = q.options.some(opt => extractImages(opt).length > 0);
        const rowHeight = hasImagesInOptions ? 2.2 : 0.4;

        q.options.forEach((opt, optIdx) => {
          const label = optionFormat === "alphabets" ? String.fromCharCode(97 + optIdx) : optIdx + 1;
          const isLeftCol = optIdx % 2 === 0;
          const columnX = isLeftCol ? col1X : col2X;
          const rowIndex = Math.floor(optIdx / 2);
          const yPos = optionsStartY + (rowIndex * rowHeight);

          const optImages = extractImages(opt);
          const cleanOptText = formatMathForPPT(opt.replace(/<img[^>]*>/gi, ""));

          slide.addText(`${label}. ${cleanOptText}`, {
            x: columnX,
            y: yPos,
            w: 5.5,
            fontSize: 12,
            fontFace: "Arial",
            color: "555555",
            valign: "top"
          });

          if (optImages.length > 0) {
            try {
              slide.addImage({
                path: optImages[0],
                x: columnX + 0.4,
                y: yPos + 0.4,
                w: 2.5, // Option images stay consistent
                h: 1.5,
                sizing: { type: "contain", w: 2.5, h: 1.5 }
              });
            } catch (err) { console.error("PPT Opt-Image Error"); }
          }
        });
      }
    });
    pres.writeFile({ fileName: `${paperName || "Question_Paper"}.pptx` });
  };


  useEffect(() => {
    if (singlePrintMode) {
      document.body.classList.add("single-print-mode");
    } else {
      document.body.classList.remove("single-print-mode");
    }

    return () => {
      document.body.classList.remove("single-print-mode");
    };
  }, [singlePrintMode]);

  


  return (
    <div className="page-container">
      {/* Left section - Settings */}

      <ToastContainer />


      <div className="settings-section ">
        <button
          onClick={() => {
            navigate("/paper-details");

          }}
          style={{
            backgroundColor: "#007bff",
            color: "#fff",
            padding: "10px 20px",
            marginBottom: "20px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Back
        </button>
        {/* //#FBEFDA */}

        <div
          className="btn-group d-flex w-100"
          role="group"
          aria-label="Basic radio toggle button group"
        >
          <input
            type="radio"
            className="btn-check"
            name="btnradio"
            id="btnradio1"
            autoComplete="off"
            checked={selected === "btnradio1"}
            onChange={() => setSelected("btnradio1")}
          />
          <label
            htmlFor="btnradio1"
            className="flex-grow-1 text-center"
            style={getButtonClass("btnradio1")}
          >
            Question Paper
          </label>

          <input
            type="radio"
            className="btn-check"
            name="btnradio"
            id="btnradio2"
            autoComplete="off"
            checked={selected === "btnradio2"}
            onChange={() => setSelected("btnradio2")}
          />
          <label
            htmlFor="btnradio2"
            className="flex-grow-1 text-center"
            style={getButtonClass("btnradio2")}
          >
            Answer Key
          </label>
        </div>

        <div>
          <div className="setting-item">
            {/* Bold Questions Checkbox */}
            {selected === "btnradio1" && (
              <div className="setting-item">
                <label>
                  <input
                    type="checkbox"
                    checked={boldQuestions}
                    onChange={() => setBoldQuestions(!boldQuestions)}
                  />
                  <span style={{ marginLeft: "8px" }}>Bold Questions</span>
                </label>
              </div>
            )}
          </div>

          <div className="setting-item">
            <input
              type="checkbox"
              checked={showWatermark}
              onChange={(e) => setShowWatermark(e.target.checked)}
            />
            <span style={{ marginLeft: "8px" }}>Water Mark</span>
          </div>

          <div className="setting-item">
            <label>
              <input
                type="checkbox"
                checked={showTopicsCovered}
                onChange={handleCheckboxChange}
              />
              <span style={{ marginLeft: "8px" }}>Topics Covered</span>
            </label>
          </div>

          <div className="setting-item">
            <label>
              <input
                type="checkbox"
                checked={showChaptersCovered}
                onChange={handleCheckboxChange2}
              />
              <span style={{ marginLeft: "8px" }}>Chapters Covered</span>
            </label>
          </div>

          <div className="setting-item" style={{ marginTop: "15px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                width: "max-content",
              }}
            >
              <div>
                <label>Font Style:</label>
                <select
                  className="form-control text-16 text-black text-inherit rounded-4 text-center"
                  onChange={(e) => setFontStyle(e.target.value)}
                  value={fontStyle}
                >
                  <option value="'Arial', sans-serif">Arial</option>
                  <option value="'Times New Roman', serif">Times New Roman</option>
                  <option value="'Verdana', sans-serif">Verdana</option>
                  <option value="'Courier New', monospace">Courier New</option>
                  <option value="'Open Sans', sans-serif">Sans-serif (Open Sans)</option>
                  <option value="'URW Bookman', 'Bookman Old Style', 'Libre Bookman', serif">
                    Bookman Old Style
                  </option>


                </select>
              </div>

              <div>
                <label>Font Size:</label>
                <div className="flex-align flex-wrap ">
                  <select
                    className="form-control   text-16 text-balck text-inherit rounded-4 text-center"
                    onChange={(e) => setFontSize(e.target.value)}
                    value={fontSize}
                  >
                    <option value="9px">9px</option>
                    <option value="10px">10px</option>
                    <option value="11px">11px</option>
                    <option value="12px">12px</option>
                    <option value="13px">13px</option>

                    <option value="14px">14px</option>
                    <option value="15px">15px</option>
                    <option value="20px">20px</option>
                    <option value="24px">24px</option>
                    <option value="28px">28px</option> <option value="32px">32px</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              width: "max-content",
            }}
          >

            <div
              className="align-items-center setting-item"
              style={{ marginTop: "15px" }}
            >
              <label>Options</label>
              <select
                className="form-control fw-medium"
                style={{ width: "120px" }}
                value={optionFormat}
                onChange={(e) => setOptionFormat(e.target.value)}
              >
                <option value="alphabets">Alphabets</option>
                <option value="numbers">Numbers</option>
              </select>
            </div>



          </div>

          {hasGeneratedSets && (
            <div className="setting-item" style={{ marginTop: "10px" }}>
              <label style={{ cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={showOriginalPaper}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setShowOriginalPaper(checked);

                    if (!checked) {
                      setIsSetQuestionsReady(false); // force loader before set loads
                    }
                  }}
                />

                <span style={{ marginLeft: "8px", fontWeight: "600" }}>
                  Original Paper
                </span>
              </label>
            </div>
          )}


          {/* ✅ IF SETS ALREADY GENERATED → SHOW SET SELECTOR */}
          {hasGeneratedSets ? (
            <div className="setting-item" style={{ marginTop: "15px" }}>
              <label>Select Set</label>
              <select
                className="form-control fw-medium"
                style={{ width: "160px" }}
                value={selectedSet}
                onChange={(e) => setSelectedSet(e.target.value)}
              >
                {generatedSets.map((set) => (
                  <option key={set.setNumber} value={set.setNumber}>
                    Set {set.setNumber} ({set.questionCount} Q)
                  </option>
                ))}
              </select>
            </div>
          ) : (
            /* ✅ IF NO SETS → SHOW GENERATE UI */
            <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
              <div>
                <label>No. of Sets</label>
                <select
                  className="form-control fw-medium"
                  style={{ width: "120px" }}
                  value={numberOfSets}
                  onChange={(e) => setNumberOfSets(e.target.value)}
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>

              <div style={{ display: "flex", alignItems: "end" }}>
                <button
                  className="btn btn-success"
                  onClick={handleGenerateSets}
                  disabled={isGenerating}
                  style={{
                    minWidth: "120px",
                    opacity: isGenerating ? 0.7 : 1,
                    cursor: isGenerating ? "not-allowed" : "pointer",
                  }}
                >
                  {isGenerating ? (
                    <span>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ marginRight: "6px" }}
                      />
                      Generating...
                    </span>
                  ) : (
                    "Generate"
                  )}
                </button>

              </div>
            </div>
          )}



          {/* <div className="setting-item" style={{ marginTop: "20px" }}>
            <label>Rough Space:</label>
            <input
              type="text"
              value={roughSpace}
              onChange={(e) => setRoughSpace(e.target.value)}
              placeholder="Enter rough space here"
              style={{ width: "100%", marginTop: "5px", padding: "10px" }}
            />
          </div> */}
          {selected === "btnradio1" && (
            <div className="setting-item" style={{ marginTop: "15px" }}>
              <label>Options Layout:</label>
              <select
                onChange={(e) => setOptionLayout(e.target.value)}
                value={optionLayout}
                className="form-control   text-16 text-balck text-inherit rounded-4 text-center"
              >
                <option value="1">1 Column</option>
                <option value="2">2 Columns</option>
                {/* <option value="4">4 Columns</option> */}
              </select>
            </div>
          )}
        </div>

        <div className="setting-item">

          {/* PRINT MODE */}
          <label style={{ display: "block" }}>
            <input
              type="checkbox"
              checked={singlePrintMode}
              onChange={(e) => {
                const checked = e.target.checked;
                setSinglePrintMode(checked);

                if (checked) {
                  setSinglePPTMode(false);
                }
              }}
            />
            <span style={{ marginLeft: "8px" }}>
              Single Question per Page
            </span>
          </label>


          {/* PPT MODE */}
          <label style={{ display: "block", marginTop: "5px" }}>
            <input
              type="checkbox"
              checked={singlePPTMode}
              onChange={(e) => {
                const checked = e.target.checked;
                setSinglePPTMode(checked);

                if (checked) {
                  setSinglePrintMode(false);
                }
              }}
            />
            <span style={{ marginLeft: "8px" }}>
              Single Question per Page PPT
            </span>
          </label>

        </div>

        <div className="setting-item">
          <label style={{ marginBottom: "5px" }}>Layout:</label>
          <div className="radio-buttons d-flex ">
            {/* Single Layout */}
            <label
              className={`icon-radio ${layout === "single" ? "checked" : ""}`}
            >
              <input
                type="radio"
                value="single"
                checked={layout === "single"}
                onChange={(e) => setLayout(e.target.value)}
              />
              <div className="icon-container">
                <TextAlignJustify size={32} />
              </div>
            </label>

            {/* Double Layout */}
            <label
              className={`icon-radio ${layout === "double" ? "checked" : ""}`}
            >
              <input
                type="radio"
                value="double"
                checked={layout === "double"}
                onChange={(e) => setLayout(e.target.value)}
              />
              <div className="icon-container">
                <TextColumns size={32} />
              </div>
            </label>
          </div>
        </div>
        {/* <button onClick={exportToExcel2} className="btn btn-success mt-3">
          Download Excel
        </button>
        ; */}
        <button
          onClick={() => handlePrint(false)} // Normal print
          className="print-button"
          style={{
            backgroundColor: "black",
            color: "white",
            fontWeight: "bold",
            padding: "10px 20px",
            borderRadius: "10px",
            marginRight: "10px",
            width: "300px",
          }}
        >
          Print
        </button>
        {selected === "btnradio1" && (
          <button
            onClick={() => handlePrint(true)} // Teacher's print
            className="print-button"
            style={{
              backgroundColor: "darkblue",
              color: "white",
              fontWeight: "bold",
              padding: "10px 20px",
              borderRadius: "10px",
              width: "300px",
            }}
          >
            Print for Teacher
          </button>
        )}
      </div>

      {/* Right section - Question Paper */}

      <div className={`question-paper 
    ${showWatermark ? "watermark" : ""} 
 ${singlePrintMode ? "single-question-mode" : ""}
  `} style={{ position: "relative" }}>

        <div className="row">
          <div
            className="col"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={print}
              alt="Logo"
              className="print-logo"
              style={{ width: "100%", height: "150px" }}
            />
          </div>
          <div className=" print-logo" style={{ textAlign: "center", marginTop: "10px" }}>
            <p
              contentEditable="true"
              title="Click to edit"
              style={{
                border: "1px solid black",
                borderRadius: "20px",
                padding: "5px 15px",
                display: "inline-block",
                fontSize: "18px",
                fontWeight: "bold",
                backgroundColor: "#f8f8f8",
              }}
            >
              {paperName || "1st PU NEET 09 DEC 2024"}
            </p>

            {isSetMode && isSetQuestionsReady && !showOriginalPaper && (
              <p style={{ marginTop: "5px", fontWeight: "600" }}>
                Set No. {selectedSet}
              </p>
            )}



            {printForTeacher && (
              <p style={{ fontWeight: "bold", color: "red" }}>Teacher Copy</p>
            )}
          </div>

          {/* <div
            className="col-10 sar"
            // style={{
            //   display: "flex",
            //   flexDirection: "column",
            //   justifyContent: "center",
            //   alignItems: "center",
            //   marginLeft: "-70px",
            // }}
          >
            <h4 style={{ marginBottom: "0px" }}>
              SARVAJNA AND JUSTICE SHIVARAJ PATIL COLLEGE
            </h4>
            <h6 style={{ marginBottom: "0px" }}>
              BEHIND SAIMANDIR HIGHCOURT RINGROAD GULBARGA
            </h6>
            <h6 style={{ marginBottom: "0px" }}>Kalaburgi, Karnataka 585102</h6>
            <p
              contenteditable="true"
              title="Click to edit"
              style={{
                border: "1px black solid",
                borderRadius: "20px",
                paddingLeft: "10px",
                paddingRight: "10px",

                marginTop: "10px",
              }}
            >
              <b>1st PU NEET 09 DEC 2024 </b>
            </p>
            {printForTeacher && <p>Teacher Copy</p>}
          </div> */}

          {selected === "btnradio1" && (
            <>
              <div
                className="tdm print-logo"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "10px",
                  marginBottom: "10px",
                }}
              >
                <div>
                  <h6
                    style={{ marginBottom: "0" }}
                    contenteditable="true"
                    title="Click to edit"
                  >
                    <b>Class </b>
                  </h6>

                  <h6
                    style={{ marginBottom: "0" }}
                    contentEditable="true"
                    title="Click to edit"
                  >
                    <b>Time: {durationInHours || "/hrs"}</b>
                  </h6>
                </div>

                <div>
                  <h6
                    style={{ marginBottom: "0" }}
                    contentEditable="true"
                    title="Click to edit"
                  >
                    <b>Date: {formattedDate || "DD/MM/YYYY"}</b>
                  </h6>

                  <h6
                    style={{ marginBottom: "0" }}
                    contenteditable="true"
                    title="Click to edit"
                  >
                    <b>Total Marks: 5 X 10 = 50</b>
                  </h6>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="print-logo" style={{ color: "black", border: "1px solid black" }} />
        <div
          className="print-logo"
          style={{
            color: "black",
            border: "3px solid black",
            marginTop: "3px",
          }}
        />
        {selected === "btnradio1" && (
          <div
            className="tdm print-logo"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              fontSize: "10px",
              marginBottom: "10px",
            }}
          ></div>
        )}

        {showChaptersCovered && (
          <div
            className="tdm print-logo"
            style={{
              border: "1px solid #DDDDDD",
              fontSize,
              padding: "5px",
              marginBottom: "10px",
            }}
          >
            <div contentEditable="true" style={{ marginTop: "5px" }}>{renderChapters()}</div>{" "}
            {/* Render the topics here */}
          </div>
        )}

        {showTopicsCovered && (
          <div
            className="tdm print-logo"

            style={{
              border: "1px solid #DDDDDD",
              fontSize,
              padding: "5px",
              marginBottom: "10px",
            }}
          >
            <p>
              <b>Topics Covered: </b>
            </p>
            <div contentEditable="true" style={{ marginTop: "5px" }}>{renderTopics()}</div>{" "}
            {/* Render the topics here */}
          </div>
        )}

        {selected === "btnradio1" ? (
          <>
            <div className={`question-paper-content ${layout}`} style={{ marginBottom: "50px" }}>
              {/* Show Loader while fetching */}
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: 0,
                    height: "100vh",
                  }}
                >
                  <RingLoader color="black" size={100} />
                  <p
                    style={{
                      marginTop: 10,
                      fontSize: 18,
                      color: "#555",
                      fontWeight: "500",
                    }}
                  >
                    Rendering LaTeX...
                  </p>
                </div>
              ) : isSetMode && !isSetQuestionsReady ? (
                /* ✅ SET MODE WAIT STATE (NO FLASH) */
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: 0,
                    height: "100vh",
                  }}
                >
                  <RingLoader color="black" size={80} />
                  <p style={{ marginTop: "10px", fontWeight: "500" }}>
                    {showOriginalPaper
                      ? "Loading Original Paper..."
                      : `Loading Set ${selectedSet}...`}
                  </p>
                </div>
              ) : (
                /* ✅ NORMAL / SET QUESTIONS RENDER */
                Object.entries(activeQuestionsBySection).map(
                  ([sectionNumber, section]) => (
                    <div key={sectionNumber} style={{ marginBottom: "20px" }}>
                      <h6
                        contentEditable="true"
                        title="Click to edit"
                        className="section-title"
                        style={{
                          backgroundColor: "#DDDDDD",
                          paddingLeft: "10px"
                          // textAlign: "center",
                        }}
                      >
                        {section.sectionName}
                      </h6>

                      <div>
                        {section.questions.map((question, index) => {

                          const qKey = getQuestionKey(question);
                          const smartLayout = getSmartOptionLayout(question.options);

                          return (
                            <div
                              key={index}
                              className={singlePrintMode ? "single-question-page" : ""}
                              style={{ fontSize }}
                            >

                              {/* ✅ College Header for Single Print Mode */}
                              {singlePrintMode && (
                                <div className="single-print-header">
                                  <div className="college-name">
                                  Onezo PU College Kalaburgi & Raichur
                                  </div>
                                  <div className="college-line" />
                                </div>
                              )}

                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  justifyContent: "space-between",
                                  gap: "12px",
                                  marginBottom: "6px",
                                }}
                              >
                                {/* Question Number + Text */}
                                <div style={{ display: "flex", flex: 1 }}>
                                  <strong
                                    style={{
                                      marginRight: "6px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {index + 1 + section.startIndex}.
                                  </strong>

                                  <span
                                    className="normal-inline"
                                    style={{ fontWeight: boldQuestions ? 1000 : 500 }}
                                  >
                                    {renderLatexText(question.question)}
                                  </span>
                                </div>

                                {/* Force 2 Column Checkbox (Right Side) */}
                                <label
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    fontSize: "11px",
                                    whiteSpace: "nowrap",
                                    cursor: "pointer",
                                    color: "#444",
                                    userSelect: "none",
                                  }}
                                  className="force-checkbox"
                                >


                                  <input
                                    type="checkbox"
                                    checked={!!forcedTwoCol[qKey]}
                                    onChange={() => toggleForceTwoCol(qKey)}
                                    style={{ cursor: "pointer" }}
                                  />

                                  Force 2 Col
                                </label>
                              </div>

                              {/* Options */}
                              <div

                                className={classNames("options-list", {

                                  // normal mode
                                  "one-column":
                                    !isSinglePrintMode && optionLayout === "1",

                                  "force-two-columns":
                                    (isSinglePrintMode || optionLayout === "2") &&
                                    forcedTwoCol[getQuestionKey(question)],

                                  // single print mode ALWAYS uses smart layout
                                  "single-row-options":
                                    (isSinglePrintMode || optionLayout === "2") &&
                                    !forcedTwoCol[getQuestionKey(question)] &&
                                    smartLayout === "single-row",

                                  "auto-two-columns":
                                    (isSinglePrintMode || optionLayout === "2") &&
                                    !forcedTwoCol[getQuestionKey(question)] &&
                                    smartLayout === "two-column",

                                  "stacked-options":
                                    (isSinglePrintMode || optionLayout === "2") &&
                                    !forcedTwoCol[getQuestionKey(question)] &&
                                    smartLayout === "stack",

                                })}
                                style={{ paddingLeft: "14px" }}
                              >

                                {question.options && question.options.length > 0 ? (
                                  <ul
                                    style={{
                                      padding: 0,
                                      margin: 0,
                                      listStyleType: "none",
                                    }}
                                  >
                                    {question.options.map((option, idx) => (
                                      <li
                                        key={idx}
                                        style={{
                                          marginBottom: "4px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        <strong>
                                          {optionFormat === "alphabets"
                                            ? String.fromCharCode(97 + idx)
                                            : idx + 1}
                                          .
                                        </strong>{" "}
                                        {renderLatexText(option)}
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <div
                                  // style={{
                                  //   fontSize,
                                  //   fontWeight: "bold",
                                  //   marginTop: "8px",
                                  // }}
                                  >
                                    {/* Ans.{" "}
                                    <span
                                      style={{
                                        borderBottom: "1px dotted gray",
                                        padding: "0 200px",
                                      }}
                                    />*/}
                                  </div>
                                )}
                              </div>

                              {/* Teacher Answer */}
                              {
                                printForTeacher && (
                                  <div style={{ marginTop: "10px" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <strong>
                                        Answer: ({question.optionId}){" "}
                                        {renderLatexText(question.answer)}
                                      </strong>
                                      <strong>
                                        Question Id:{" "}
                                        {isSetMode
                                          ? question.questionId || "N/A"
                                          : question.id || "N/A"}
                                      </strong>
                                    </div>
                                    <div style={{ marginTop: "10px", maxWidth: "350px" }}>
                                      <strong>Explanation:</strong>{" "}
                                      {renderLatexText(question.explanation)}
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  )
                )
              )}
            </div>



            {/* <div className="print-footer">
  Sarvajna & Justice Shivaraj Patil PU College Kalaburgi & Raichur
</div> */}


            {loading ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100vh",
                  pageBreakBefore: "always",
                }}
              >
                <RingLoader color="black" size={100} />
                <p
                  style={{
                    marginTop: 10,
                    fontSize: 18,
                    color: "#555",
                    fontWeight: "500",
                  }}
                >
                  Generating Answer Key...
                </p>
              </div>
            ) : (
              <div className="answer-key-page no-columns" style={{ pageBreakBefore: "always" }}>

                <div className="text-center mb-5" style={{ fontSize }}>
                  <strong>Answer Key:</strong>
                </div>
                <div
                  style={{
                    display: "flex",
                    fontSize,
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "30px",
                  }}
                >
                  <table border="1" style={{ borderCollapse: "collapse" }}>
                    <tbody>
                      {Object.values(activeQuestionsBySection)
                        .flatMap((section) => section.questions) // Flatten all questions into one array
                        .reduce((rows, question, index) => {
                          const rowIndex = Math.floor(index / 10); // Group answers into rows of 10
                          if (!rows[rowIndex]) {
                            rows[rowIndex] = [];
                          }
                          rows[rowIndex].push(
                            <td
                              key={index}
                              style={{
                                fontSize,
                                wordWrap: "break-word",
                                verticalAlign: "top",
                                textAlign: "center", // Align the answers in the center
                                border: "1px solid black", // Add border to each cell for clarity
                                padding: "8px",
                              }}
                            >
                              {/* Answer Text */}
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                }}
                              >
                                <span
                                  style={{
                                    marginRight: "5px",
                                    whiteSpace: "nowrap",
                                    alignSelf: "flex-start",
                                  }}
                                >
                                  <strong>{index + 1})</strong>
                                </span>
                                <span
                                  style={{
                                    fontWeight: boldQuestions ? "bold" : "normal",
                                  }}
                                >
                                  {question.questionType === "3" ? (
                                    // ✅ SUBJECTIVE → show Answer or Explanation directly
                                    renderLatexText(
                                      question.answer || question.explanation || "—"
                                    )
                                  ) : (
                                    // ✅ MCQ → keep existing logic
                                    <>
                                      {question.options && question.options.length > 0 && question.optionId ? (
                                        renderLatexText(
                                          optionFormat === "alphabets"
                                            ? String.fromCharCode(64 + Number(question.optionId))
                                            : question.optionId
                                        )
                                      ) : (
                                        renderLatexText(
                                          question.answer || question.explanation || "—"
                                        )
                                      )}

                                    </>
                                  )}


                                </span>
                              </div>
                            </td>
                          );
                          return rows;
                        }, [])
                        .map((row, rowIndex) => (
                          <tr
                            key={rowIndex}
                            style={{ borderBottom: "1px solid #ddd" }}
                          >
                            {/* Add border to each row */}
                            {row}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>)}
          </>
        ) : (
          <div
            className={`question-paper-content`}
            style={{
              marginTop: "50px",
              marginBottom: "200px",
            }}
          >
            <button
              className="exel"
              onClick={exportToExcel}
              style={{
                backgroundColor: "#4CAF50",
                color: "white",
                padding: "10px 20px",
                marginBottom: "20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Export to Excel
            </button>
            {/* Table Container */}
            <div className="text-center mb-5" style={{ fontSize }}>
              <strong>Answer Key:</strong>
            </div>
            <div
              style={{
                display: "flex",
                fontSize,
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "30px",
              }}
            >
              <table border="1" style={{ borderCollapse: "collapse" }}>
                <tbody>
                  {Object.values(activeQuestionsBySection)
                    .flatMap((section) => section.questions) // Flatten all questions into one array
                    .reduce((rows, question, index) => {
                      const rowIndex = Math.floor(index / 10); // Group answers into rows of 10
                      if (!rows[rowIndex]) {
                        rows[rowIndex] = [];
                      }
                      rows[rowIndex].push(
                        <td
                          key={index}
                          style={{
                            fontSize,
                            wordWrap: "break-word",
                            verticalAlign: "top",
                            textAlign: "center", // Align the answers in the center
                            border: "1px solid black", // Add border to each cell for clarity
                            padding: "8px",
                          }}
                        >
                          {/* Answer Text */}
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                            }}
                          >
                            <span
                              style={{
                                marginRight: "5px",
                                whiteSpace: "nowrap",
                                alignSelf: "flex-start",
                              }}
                            >
                              <strong>{index + 1})</strong>
                            </span>
                            <span
                              style={{
                                fontWeight: boldQuestions ? "bold" : "normal",
                              }}
                            >
                              {question.questionType === "3" ? (
                                // ✅ SUBJECTIVE → show Answer or Explanation directly
                                renderLatexText(
                                  question.answer || question.explanation || "—"
                                )
                              ) : (
                                // ✅ MCQ → keep existing logic
                                <>
                                  {question.options && question.options.length > 0 && question.optionId ? (
                                    renderLatexText(
                                      optionFormat === "alphabets"
                                        ? String.fromCharCode(64 + Number(question.optionId))
                                        : question.optionId
                                    )
                                  ) : (
                                    renderLatexText(
                                      question.answer || question.explanation || "—"
                                    )
                                  )}

                                </>

                              )}


                            </span>
                          </div>
                        </td>
                      );
                      return rows;
                    }, [])
                    .map((row, rowIndex) => (
                      <tr
                        key={rowIndex}
                        style={{ borderBottom: "1px solid #ddd" }}
                      >
                        {/* Add border to each row */}
                        {row}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div style={{ paddingLeft: "20px" }}>
              <p style={{ fontSize }}>
                <strong>Hint & Solutions</strong>
              </p>
              <ul className={`question-paper-content ${layout}`}>
                {/* Display questions in cards side by side */}
                {Object.values(activeQuestionsBySection)
                  .flatMap((section) => section.questions) // Flatten all questions into one array
                  .map((question, index) => (
                    <div
                      key={index}
                      className="card"
                      style={{
                        fontSize,

                        marginTop: "10px",
                      }}
                    >
                      <p
                        style={{
                          display: "block",

                          fontWeight: boldQuestions ? "bold" : "normal",
                        }}
                      >
                        <strong>{index + 1}.</strong>
                        {question.options && question.options.length === 0 ? (
                          <p>
                            <strong>Answer:</strong>{" "}
                            {renderLatexText(question.explanation)}
                          </p>
                        ) : (
                          <p>
                            ({renderLatexText(question.optionId)}){" "}
                            {renderLatexText(question.answer)}
                          </p>
                        )}
                      </p>
                      {/* Add explanation on a new line */}
                      {question.options &&
                        question.options.length > 0 &&
                        question.explanation && (
                          <div style={{ marginTop: "8px" }}>
                            <strong>Explanation:</strong>{" "}
                            {renderLatexText(question.explanation)}
                          </div>
                        )}
                    </div>
                  ))}
              </ul>
            </div>

            {/* Card List Container */}

          </div>
        )}


      </div>

    </div >
  );
};

export default ViewPaper;
